import { ClassTypeStore } from "@fitness-force/models";

export const CLASS_TYPE_STATE:ClassTypeStore =   {
    classTypes:[]
} 